// pw-notify-me — sold-out email capture. Plain JS, no classes, no
// custom elements, no framework. Click pill, type email, submit, done.

(function () {
  if (window.__pwNotifyInit) return;
  window.__pwNotifyInit = true;

  function open(root) {
    var modal = root.querySelector('[data-pw-notify-modal]');
    var form = root.querySelector('[data-pw-notify-form]');
    var success = root.querySelector('[data-pw-notify-success]');
    var helper = root.querySelector('[data-pw-notify-helper]');
    var email = root.querySelector('[data-pw-notify-email]');
    var consent = root.querySelector('[data-pw-notify-consent]');
    if (form) form.hidden = false;
    if (success) success.hidden = true;
    if (helper) helper.textContent = '';
    if (email) email.value = '';
    if (consent) consent.checked = false;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (email) email.focus(); }, 30);
  }

  function close(root) {
    var modal = root.querySelector('[data-pw-notify-modal]');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
  }

  function submit(root) {
    var emailInput = root.querySelector('[data-pw-notify-email]');
    var consent = root.querySelector('[data-pw-notify-consent]');
    var helper = root.querySelector('[data-pw-notify-helper]');
    var form = root.querySelector('[data-pw-notify-form]');
    var success = root.querySelector('[data-pw-notify-success]');

    var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (helper) helper.textContent = 'Please enter a valid email address.';
      if (helper) helper.dataset.tone = 'error';
      if (emailInput) emailInput.focus();
      return;
    }
    if (consent && !consent.checked) {
      if (helper) helper.textContent = 'Please confirm consent to continue.';
      if (helper) helper.dataset.tone = 'error';
      consent.focus();
      return;
    }

    // Klaviyo path
    var key = root.dataset.klaviyoKey;
    var variantId = root.dataset.variantId;
    var listId = root.dataset.klaviyoList;

    function showSuccess() {
      if (form) form.hidden = true;
      if (success) success.hidden = false;
    }

    function queueLocal() {
      try {
        var queue = JSON.parse(localStorage.getItem('pw-notify-queue') || '[]');
        queue.push({
          email: email,
          variantId: variantId,
          productHandle: root.dataset.productHandle,
          productTitle: root.dataset.productTitle,
          consentedAt: new Date().toISOString()
        });
        localStorage.setItem('pw-notify-queue', JSON.stringify(queue));
      } catch (e) { /* ignore */ }
      showSuccess();
    }

    if (!key) {
      queueLocal();
      return;
    }

    var body = new URLSearchParams();
    body.append('a', key);
    body.append('email', email);
    body.append('variant', variantId);
    body.append('platform', 'shopify');
    if (listId) body.append('g', listId);

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: body
    }).then(function (res) {
      if (!res.ok) throw new Error('subscribe failed');
      return res.json().catch(function () { return {}; });
    }).then(function () {
      showSuccess();
    }).catch(function () {
      // Network/CORS/Klaviyo errors — still queue locally so we don't lose
      // the lead. The user gets a success state either way.
      queueLocal();
    });
  }

  // Single delegated click listener — open, close, submit.
  // Submit detection is forgiving: data-pw-notify-submit on the new
  // markup, OR any button inside [data-pw-notify-form] / [data-action="confirm"]
  // for legacy markup that may still be served from Shopify edge cache.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var openBtn = t.closest('[data-pw-notify-open], [data-action="open"]');
    if (openBtn) {
      var r1 = openBtn.closest('[data-pw-notify], pw-notify-me, .pw-notify');
      if (r1) { e.preventDefault(); open(r1); }
      return;
    }
    var submitBtn = t.closest('[data-pw-notify-submit], [data-action="confirm"], [data-pw-notify-form] button[type="submit"], .pw-notify__form button[type="submit"]');
    if (submitBtn) {
      var r2 = submitBtn.closest('[data-pw-notify], pw-notify-me, .pw-notify');
      if (r2) { e.preventDefault(); submit(r2); }
      return;
    }
    var closeBtn = t.closest('[data-pw-notify-close], [data-action="close"]');
    if (closeBtn) {
      var r3 = closeBtn.closest('[data-pw-notify], pw-notify-me, .pw-notify');
      if (r3) { e.preventDefault(); close(r3); }
      return;
    }
  });

  // Belt-and-braces: if the legacy <form> still renders (cached HTML),
  // intercept its submit too. The new markup uses a <div> so this is
  // a no-op there.
  document.addEventListener('submit', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.tagName !== 'FORM') return;
    if (!(t.matches('[data-pw-notify-form]') || t.classList.contains('pw-notify__form'))) return;
    e.preventDefault();
    var root = t.closest('[data-pw-notify], pw-notify-me, .pw-notify');
    if (root) submit(root);
  }, true);

  // Enter on the email input submits.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.querySelector('[data-pw-notify-modal]:not([hidden])');
      if (!modal) return;
      var rE = modal.closest('[data-pw-notify]');
      if (rE) close(rE);
      return;
    }
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (!t.matches('[data-pw-notify-email]')) return;
    e.preventDefault();
    var rEnter = t.closest('[data-pw-notify]');
    if (rEnter) submit(rEnter);
  });
})();
